import styled from 'styled-components';

export const Container = styled.div`
  height: 113px;
  border-bottom: 1px solid #e6e6e6;

  .row-skeleton {
    height: 24px;
    width: 80%;
  }

  .row-skeleton.progress-bar {
    height: 12px;
    width: 100%;
    border-radius: 50px;
  }

  .row-skeleton.value{
    max-width: 86px;
  }

  .row-skeleton.button {
    height: 35px;
    max-width: 113px;
    margin: 2px 30px;
    border-radius: 8px;
  }
`;
